import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getAbout } from '../actions/MainAction';
export class AboutPage extends Component {
  openModal=(data, lang, lang_id=1)=>{
    // console.log(lang, lang_id)
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        phone_1: data?.phone_1?data?.phone_1:"",
        phone_2: data?.phone_2?data?.phone_2:"",
        // phone_3: data?.phone_3?data?.phone_3:"",
        whatsapp_1: data?.whatsapp_1?data?.whatsapp_1:"",
        whatsapp_2: data?.whatsapp_2?data?.whatsapp_2:"",
        // whatsapp_3: data?.whatsapp_3?data?.whatsapp_3:"",
        email: data?.email?data?.email:"",
        email_1: data?.email_1?data?.email_1:"",
        address: data?.address?data?.address:"",
        address_1: data?.address_1?data?.address_1:"",
        instagram: data?.instagram?data?.instagram:"",
        youtube: data?.youtube?data?.youtube:"",
       
        languages:{}
        ,
        requiredsLang: [],
        requireds:[],
        afterCallFunction:this.props.getAbout,
        afterParams:[],
        url:'admin-contact'
      }
    })
  }

  componentDidMount(){
    this.props.getAbout()
  }
  render() {
    const {aboutData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header btn={false} onClickBtn={this.openModal.bind(this, "", "", 1)} title="Əlaqə Vasitələri" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            aboutData?
                <Card1 
                  onChangeLang={(id)=>this.openModal(aboutData, "", id)} 
                  title1={aboutData?.email}
                  deleteUrl={`admin-contact/${aboutData?.id}`}
                  afterCallFunction={()=> this.props.getAbout()}
                  deleteBtn={false}
                />:null
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  aboutData: state.Data.aboutData
});
const mapDispatchToProps = {changeStateValue, getAbout}
export default connect(mapStateToProps, mapDispatchToProps)(AboutPage)




